/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import Empty from './Empty/index'
import Error from './Error/index'
import Loading from './Loading/index'
import No from './No/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/BillingCenter/Content/Options/Edit/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="small"
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<TysiaHeading
{...childProps}
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Edit Billing Center"
/>
)}
</TysiaModalHeader>
<fromFlow.When is={flowValue === 'No'}>
<No
{...childProps}
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
{...childProps}
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
{...childProps}
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Empty'}>
<Empty
{...childProps}
  viewPath={`${viewPath}/Empty`}
/>
</fromFlow.When>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}